// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1779868616076
      var cssReload = require("/Users/wp/Desktop/chuanti-pc/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  